import { clsx } from 'clsx';

/** Theme-aware classes for native form controls (select, input, textarea). */
export const nativeFieldClassName = clsx(
  'border rounded-lg transition-colors duration-200',
  'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent',
  'bg-app-surface text-app-text border-gray-300',
  'dark:bg-gray-800 dark:border-gray-600 dark:text-white dark:[color-scheme:dark]',
);

export const nativeSelectClassName = nativeFieldClassName;

export const fieldLabelClassName = 'text-sm font-medium text-app-text dark:text-gray-300';

export const fieldLabelSmClassName = 'text-xs font-medium text-app-text dark:text-gray-300';

export const mutedTextClassName = 'text-app-text-muted dark:text-gray-400';
